export const isLocalhost = (host: string) => {
  return host.includes('localhost') || host.includes('127.0.0.1');
};
